<template>
  <div class="loginbox">

  </div>
</template>

<script>

  export default {
    data () {
      return {

      }
    },
    created() {
      let host = ''
      if(process.env.NODE_ENV=='local'){
        host = 'http://open-base.imcoming.com.cn/wechatDev'
      }else if(process.env.NODE_ENV=='development'){
        host = 'http://open-base.imcoming.com.cn/wechatDev'
      }else if(process.env.NODE_ENV=='test'){
        host = 'http://open-base.imcoming.com/wechatDev'
      }else{
        host = 'https://open-base.anlaiye.com/wechat'
      }
       window.location.href = host+'/auth/enter?redirect=market'
    }

  }
</script>



// WEBPACK FOOTER //
// Auth.vue?452b47d4